// 导航守卫
import router from "@/router";
import store from "@/store";
import Router from "vue-router";
import { constantRoutes } from "./router/index";
// 把不需要登录的页面用 白名单 变量保存着
const whitePage = ["/login", "/404", "/401"];

// 前置守卫
router.beforeEach(async (to, from, next) => {
  // 根标签名
  document.title = "乂安智检";

  // 有tonke
  // if (store.state.user.token) {
  // 如果是登录页(考虑大小写的情况toLowerCase())
  if (to.path.toLowerCase() === "/login") {
    return next("/");
    //   next()
  } else {
    if (to.matched.length === 0 && from.path != "/") {
      from.path === to.path ? next({ path: from.path }) : next("/404");
    }
    next();
    // 验证token是否过期
    if (store.state.permission.routes.length == 0) {
      const roles = store.state.user.roles;
      const accessRoutes = await store.dispatch(
        "permission/generateRoutes",
        roles
      );
      const createRouter = () =>
        new Router({
          mode: "hash",
          scrollBehavior: () => ({ y: 0 }),
          routes: constantRoutes,
        });
      // 用初始化的matcher替换当前router的matcher
      router.matcher = createRouter().matcher;
      router.addRoutes(accessRoutes);
    }
    if (from.query.redirect && from.query.redirect !== to.path) {
      return next(from.query.redirect);
    } else {
      // 没有from.query.redirect,直接跳转
      return next();
    }
  }
  // } else {
  //   // 如果没有token 要去的页面无须登录:检查要去的页面是否在白名单
  //   if (whitePage.includes(to.path.toLowerCase())) {
  //     return next();
  //   } else {
  //     // 要去的页面需要登录则跳转到登录页
  //     return next("/login");
  //   }
  // }
});

// 后置守卫
router.afterEach(() => {});
